import React, { createContext, useState } from 'react';

export const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const initialPath = window.location.pathname;
  const [history, setHistory] = useState([initialPath]);

  return (
    <NavigationContext.Provider value={{ history, setHistory }}>
      {children}
    </NavigationContext.Provider>
  );
};
